/* Password-page newsletter scroll: delayed once-per-session prompt plus an
   always-available text trigger. Shopify handles the actual customer form. */
(function () {
  'use strict';

  var SESSION_KEY = 'poser_newsletter_prompt_seen_v1';
  var SUBSCRIBED_KEY = 'poser_newsletter_subscribed_v1';

  function storageGet(storage, key) {
    try { return storage.getItem(key); } catch (error) { return null; }
  }

  function storageSet(storage, key, value) {
    try { storage.setItem(key, value); } catch (error) {}
  }

  function init() {
    var root = document.querySelector('[data-newsletter-root]');
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var dialog = root.querySelector('[data-newsletter-dialog]');
    var email = root.querySelector('[data-newsletter-email]');
    var result = root.querySelector('[data-newsletter-result]');
    var triggers = Array.prototype.slice.call(document.querySelectorAll('[data-newsletter-open]'));
    var closeButtons = Array.prototype.slice.call(root.querySelectorAll('[data-newsletter-close]'));
    var timer = null;
    var returnFocus = null;

    function focusableElements() {
      return Array.prototype.slice.call(root.querySelectorAll(
        'button:not([disabled]):not([tabindex="-1"]), input:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])'
      )).filter(function (element) {
        return element.getClientRects().length > 0;
      });
    }

    function open(trigger) {
      if (timer) {
        window.clearTimeout(timer);
        timer = null;
      }

      returnFocus = trigger || null;
      root.inert = false;
      root.setAttribute('aria-hidden', 'false');
      root.classList.add('is-open');
      storageSet(window.sessionStorage, SESSION_KEY, '1');

      window.requestAnimationFrame(function () {
        if (result) result.focus();
        else if (email) email.focus();
        else dialog.focus();
      });
    }

    function close() {
      if (!root.classList.contains('is-open')) return;
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      root.inert = true;
      if (returnFocus && document.contains(returnFocus)) returnFocus.focus();
      returnFocus = null;
    }

    function cancelAutomaticPrompt() {
      if (!timer) return;
      window.clearTimeout(timer);
      timer = null;
      storageSet(window.sessionStorage, SESSION_KEY, '1');
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () { open(trigger); });
    });
    closeButtons.forEach(function (button) {
      button.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (event) {
      if (!root.classList.contains('is-open')) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        close();
        return;
      }
      if (event.key !== 'Tab') return;

      var focusable = focusableElements();
      if (!focusable.length) {
        event.preventDefault();
        dialog.focus();
        return;
      }

      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    var form = root.querySelector('form');
    if (form) {
      form.addEventListener('submit', function () {
        storageSet(window.sessionStorage, SESSION_KEY, '1');
      });
    }

    if (result) {
      if (result.dataset.newsletterResult === 'success') {
        storageSet(window.localStorage, SUBSCRIBED_KEY, '1');
      }
      open(null);
      return;
    }

    var passwordStage = document.querySelector('.poser-pw__stage');
    var passwordError = document.querySelector('.poser-pw__field--error');
    var alreadySeen = storageGet(window.sessionStorage, SESSION_KEY);
    var alreadySubscribed = storageGet(window.localStorage, SUBSCRIBED_KEY);
    var shouldAutoOpen = root.dataset.autoOpen === 'true' && !passwordError && !alreadySeen && !alreadySubscribed;

    if (shouldAutoOpen) {
      var delay = parseInt(root.dataset.delay, 10);
      if (!Number.isFinite(delay)) delay = 4000;
      timer = window.setTimeout(function () { open(null); }, Math.max(0, delay));

      /* Never interrupt somebody who has already started entering the password. */
      if (passwordStage) {
        passwordStage.addEventListener('pointerdown', cancelAutomaticPrompt, { once: true });
        passwordStage.addEventListener('keydown', cancelAutomaticPrompt, { once: true });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
